export { IndustryByCompanies } from './IndustryByCompanies';
